import { nexcareVersion } from '../config/serviceConfig';
import Get from '../services/Get';
import GetGrochat from '../services/GetGrochat';
import PostFormData from '../services/PostFormData';
import PostFormDataGrochat from '../services/PostFormDataGrochat';

const getSignByClientId = (clientId, token) => GetGrochat(`/v5/user/device/${clientId}`, token);
const getListRoom = (page, limit, token) => GetGrochat(`/v5/room/list?page=${page}&size=${limit}&room_type=T`, token);
const getListMessage = (roomId, page, limit, token) => GetGrochat(`/v5/message/byroomid?roomID=${roomId}&pageIndex=${page}&pageSize=${limit}&sortByCreated=true`, token);
const postUploadAttachment = (data, token) => PostFormDataGrochat(`/v1/file/upload`, data, token);
const getUserByClientId = (clientId, token) => Get(`/${nexcareVersion}/nexcare/user-nexcare/checkuser?clientId=${clientId}`, token)
const postCallHistory = (data, token) => PostFormData(`/${nexcareVersion}/nexcare/call-logging`, data, token)

const API_CHAT = {
    getSignByClientId,
    getListRoom,
    getListMessage,
    postUploadAttachment,
    getUserByClientId,
    postCallHistory
}

export default API_CHAT;